// import { richTextToArr } from './utils';
import isNull from 'lodash/isNull';

const handleData = ({ strapiPartenaires: partenaire, ...otherDatas }) => {
  const {
    // Nom: title,
    title,
    seoDescription,
    // description_seo: description,
    // adresse_postale: postalAddress = '',
    // horaires: schedules = '',
    // postalAddress = '',
    // schedules = '',
    // description_longue: longCurriculum,
    // perimetre_intervention: perimeter,
    // description_courte: shortCurriculum,
    shortCurriculum,
    url_mini_site: siteUrl,
    // telephone_international: phoneNumber,
    // forme_juridique: legalStatus,
    // capital_social: registeredCapital,
    // immatriculation_rcs_rm: registrationNumber,
    // tva_intracommunautaire: vatNumber,
    du_cote_de_chez_perge,
    ...others
  } = partenaire;

  // const postalAddressArr = richTextToArr(postalAddress);
  // const schedulesArr = richTextToArr(schedules);

  return {
    title,
    // description,
    seoDescription: seoDescription || shortCurriculum,
    author: title,
    // postalAddress: postalAddressArr,
    // schedules: schedulesArr,
    // longCurriculum,
    shortCurriculum,
    // perimeter,
    siteUrl,
    // phoneNumber,
    // legalStatus,
    // registeredCapital,
    // registrationNumber,
    // vatNumber,
    du_cote_de_chez_perge: isNull(du_cote_de_chez_perge) ? {} : du_cote_de_chez_perge,
    ...others,
    // staticMap,
    ...otherDatas,
  };
};

export { handleData };
